import { z } from 'zod';
import { SensorTypeSchema } from './SensorType';

export const TriggerIdSchema = z.object({
  type: SensorTypeSchema,
  values: z.array(z.any()),
});

export type TriggerId = z.infer<typeof TriggerIdSchema>;
